import * as React from "react";
import { IconProps } from "./types";

export const AlignTop01Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M21 3H3M12 21V7M12 7L5 14M12 7L19 14"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(AlignTop01Icon as React.FunctionComponent).displayName = "AlignTop01Icon";

export default AlignTop01Icon;
